import {CacheRules} from "./cache-rules";

export class CacheRulesServerParams {
  public BYPASS_COOKIE: string[];
  public BYPASS_PAGE_URL_REGEX: string[];
  public INCLUDE_QUERY_STRING: string[];
  public DISABLE_PAGE_CACHE: boolean;
  public DISABLE_CDN: boolean;

  constructor(data: CacheRules) {
    this.BYPASS_COOKIE = data.bypassCookie;
    this.BYPASS_PAGE_URL_REGEX = data.bypassPageUrlRegex;
    this.INCLUDE_QUERY_STRING = data.includeQueryString;
    this.DISABLE_PAGE_CACHE = !!data.disablePageCache;  // default 1
    this.DISABLE_CDN = !!data.disableCdn;  // default 0
  }
}
